import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export class MachineWriteDataAcquisitionTypeOnSelectedNodesHandler {
  writeDataAcquisitionTypeOnSelectedNodes(
    dataAcquisitionType,
    pollingIntervalTime,
  ) {
    const machineStructureNodeset = getMachineStructureNodeset();
    machineStructureNodeset.writeDataAcquisitionValuesInSelectedNodes(
      dataAcquisitionType,
      pollingIntervalTime,
    );
  }
}
